module.exports = __webpack_public_path__ + "img/4.d21b6ad2.jpg";